import {
  DEFAULT_METRICS,
  PLAYS_STAT_KEY,
} from '../ScoutPlayers/ScoutPlayers.constants';
import { DEFAULT_SCOUT_POSITION } from '../ScoutResults.constants';

export const isDefaultBiometricState = (selectedBiometrics) => {
  // Case 1: Both selected and default biometrics are empty objects
  if (Array.isArray(selectedBiometrics) && selectedBiometrics.length === 0) {
    return true;
  }

  // Case 2: selectedBiometrics is an array with the default transfer portal filter
  if (
    Array.isArray(selectedBiometrics) &&
    selectedBiometrics.length === 1 &&
    selectedBiometrics[0].key === 'ncaaTransferPortal' &&
    selectedBiometrics[0].value === false
  ) {
    return true;
  }

  return false;
};

// Add this helper above your component
export const isDefaultTemplateState = ({
  scoutTemplateId,
  selectedStats,
  selectedPositions,
  selectedBiometrics,
  showFavourites,
}) =>
  scoutTemplateId == null &&
  Array.isArray(selectedPositions) &&
  selectedPositions.length === 1 &&
  selectedPositions[0] === DEFAULT_SCOUT_POSITION &&
  Array.isArray(selectedStats) &&
  selectedStats.length === 1 &&
  selectedStats[0].key === PLAYS_STAT_KEY &&
  selectedStats[0].value === DEFAULT_METRICS[0].value &&
  showFavourites === false &&
  isDefaultBiometricState(selectedBiometrics);

// specifically: is the Save button enabled or not?
export const disableSaveTemplateState = (
  unsavedCng,
  templateId,
  creatorID,
  userId,
) => {
  const isOwner = creatorID === userId;
  switch (true) {
    // Not owner, has template: disable
    case !isOwner && !templateId && !unsavedCng:
      return true;
    // Not owner, no template: enable
    case !isOwner && !templateId && unsavedCng:
      return false;
    // Owner, no unsaved changes: disable
    case isOwner && !unsavedCng:
      return true;
    // Owner, has unsaved changes: enable
    case isOwner && unsavedCng:
      return false;
    // All other cases: disable
    default:
      return true;
  }
};
